const KEY = "memeradar_trade_platform";

const isRobinhood = (c) => (c?.chainId || "solana") === "robinhood";
// DexScreener's Robinhood token page reliably opens the exact coin's chart + trade panel
// (Axiom has no working per-token deep-link for Robinhood chain — it bounces to Discover).
const robinhoodTokenPage = (c) => c.url || `https://dexscreener.com/robinhood/${c.address}`;

export const PLATFORMS = {
  axiom: {
    label: "Axiom",
    build: (c) => (isRobinhood(c) ? robinhoodTokenPage(c) : `https://axiom.trade/t/${c.address}`),
  },
  gmgn: {
    label: "GMGN",
    build: (c) => (isRobinhood(c) ? robinhoodTokenPage(c) : `https://gmgn.ai/sol/token/${c.address}`),
  },
  photon: {
    label: "Photon",
    build: (c) => (isRobinhood(c) ? robinhoodTokenPage(c) : c.pairAddress ? `https://photon-sol.tinyastro.io/en/lp/${c.pairAddress}` : c.url),
  },
  bullx: {
    label: "BullX",
    build: (c) => (isRobinhood(c) ? robinhoodTokenPage(c) : `https://neo.bullx.io/terminal?chainId=1399811149&address=${c.address}`),
  },
  dexscreener: {
    label: "DexScreener",
    build: (c) => c.url || `https://dexscreener.com/${isRobinhood(c) ? "robinhood" : "solana"}/${c.address}`,
  },
  robinhood: {
    label: "Robinhood",
    build: (c) => {
      const sym = (c.symbol || "").toUpperCase().replace("$", "").trim();
      return sym ? `https://robinhood.com/us/en/crypto/${sym}/` : "https://robinhood.com/us/en/crypto/";
    },
  },
};

export const getTradePlatform = () => localStorage.getItem(KEY) || "axiom";
export const setTradePlatform = (p) => localStorage.setItem(KEY, p);
export const buildTradeUrl = (platform, coin) => (PLATFORMS[platform] || PLATFORMS.axiom).build(coin);
